// * Import 3rd party
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledGridBox = styled(
  Box,
  {}
)(({ theme, customProps }) => ({
  height: "100%",
  color: theme.palette.cards.heading,
  fontWeight: theme.fontWeight[300],
  fontFamily: theme.typography.fontFamily,
  // fontSize: theme.typography.fontSize,
  display: "flex",
  alignItems: "center",
  fontSize: theme.size[12],
}));

export default StyledGridBox;
